const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getInvoices(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.status) params.append('status', filters.status);
  if (filters.type) params.append('type', filters.type);
  if (filters.vendorId) params.append('vendorId', filters.vendorId);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.workOrderId) params.append('workOrderId', filters.workOrderId);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/invoices${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch invoices');
  }
  
  return response.json();
}

export async function getInvoice(orgId, invoiceId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/invoices/${invoiceId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch invoice');
  }
  
  const data = await response.json();
  return data.invoice;
}
